export default __webpack_public_path__ + "locales/ar-SA/ArchiveDialog.json?hash=c44468f405bf89cd9bda039800bb1270";